"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const root_1 = __importDefault(require("./widgets/root"));
const socket_1 = __importDefault(require("./services/socket"));
const widgets = [
    {
        key: "Admin",
        component: 'admin'
    },
    {
        key: "Profile",
        component: 'profile'
    },
    {
        key: "Chat",
        component: 'chat'
    },
    {
        key: "Directory",
        component: "directory"
    },
    {
        key: "Services",
        component: "services"
    },
    {
        key: "Experts",
        component: "experts"
    },
    {
        key: 'PaymentHistory',
        component: 'userHistory'
    },
    {
        key: 'WhatsNew',
        component: 'whatsNew'
    },
    {
        key: 'NewsFeed',
        component: 'newsFeed'
    },
    {
        key: 'LawFirmProfile',
        component: 'lawFirmProfile'
    },
    {
        key: 'LawFirmCreate',
        component: 'lawFirmCreate'
    },
    {
        key: 'NotificationCenter',
        component: 'notificationCenter'
    },
    {
        key: 'Subscription',
        component: 'subscription'
    },
];
(() => {
    if (!window.AppearMe) {
        window.AppearMe = {};
    }
    const events = [];
    window.AppearMe.Widgets = {
        Events: {
            subscribe: (title, cb) => {
                if (events.includes(title))
                    return false; // preventing adding same event more than once
                window.addEventListener(title, cb);
                events.push(title);
            },
            emit: (name, data) => {
                const event = new CustomEvent(name, { detail: data });
                window.dispatchEvent(event);
            } //emit to listener
        },
        Socket: new socket_1.default()
    };
    for (const widget of widgets) {
        Object.assign(window.AppearMe.Widgets, {
            [widget.key]: (container, options = {}) => new root_1.default({
                container: container, component: widget.component, options
            })
        });
    }
})();
